import {
  CartAndDeliveryDatesDataContext,
  CartCheckoutClient,
} from '@app/data/clients/cartCheckoutClient';
import { ContextValue } from './types';

type PartialContextValue = Partial<ContextValue>;
type MockProviderProps = {
  children: React.ReactNode;
  contextOverride?: PartialContextValue;
};

export const MockCartAndDeliveryDatesDataProvider = ({
  children,
  contextOverride,
}: MockProviderProps) => {
  return (
    <CartAndDeliveryDatesDataContext.Provider
      value={createContextValue(contextOverride)}
    >
      {children}
    </CartAndDeliveryDatesDataContext.Provider>
  );
};

const createContextValue = (contextOverride: PartialContextValue) => {
  const defaults = {
    cart: null,
    cartLoading: false,
    deliveryDates: null,
    deliveryDatesLoading: false,
    hasStartedInitialLoad: false,
    errors: [],
    client: new CartCheckoutClient({
      logging: { context: '', metricName: '' },
    }),
    dispatch: jest.fn(),
  };

  return { ...defaults, ...contextOverride };
};
